import { render, staticRenderFns } from "./BrandsProductsByKeyword.vue?vue&type=template&id=73c25700&scoped=true&"
import script from "./BrandsProductsByKeyword.vue?vue&type=script&lang=js&"
export * from "./BrandsProductsByKeyword.vue?vue&type=script&lang=js&"
import style0 from "./BrandsProductsByKeyword.vue?vue&type=style&index=0&id=73c25700&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c25700",
  null
  
)

component.options.__file = "BrandsProductsByKeyword.vue"
export default component.exports